exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Dropdown Tipo envio */\n/deep/ body .tipo-envio-dropdown > div {\n  width: inherit !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/Mensajes/nuevo/nuevo.mensaje.component.scss
// module id = ../../../../../src/app/views/Mensajes/nuevo/nuevo.mensaje.component.scss
// module chunks = main